import React, { useMemo } from 'react'

import { IMetric, MetricStatus } from 'types/GlobalMetric'
import { SxProps } from '@mui/material'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'

import NavigationItem from 'components_new/molecules/NavigationItem'
import SectionHeader from 'components_new/molecules/SectionHeader'

import { translateMetricStatus } from 'utils/enumTranslator'
interface Props {
  metrics: IMetric[]
  setStatus: (value: string | null) => void
  status: string | null
  sx?: SxProps
}

const MetricsStatusOverview = React.memo((props: Props) => {
  const { metrics, setStatus, status, sx } = props
  const { t, translateEnum } = useTranslation()

  const counts = useMemo(() => {
    return {
      [MetricStatus.ACTIVE]: metrics.filter(
        (metric) => metric.status === MetricStatus.ACTIVE
      ).length,
      [MetricStatus.INACTIVE]: metrics.filter(
        (metric) => metric.status === MetricStatus.INACTIVE
      ).length,
      [MetricStatus.MISSING_DATA]: metrics.filter(
        (metric) => metric.status === MetricStatus.MISSING_DATA
      ).length,
      [MetricStatus.MISSING_SLICES]: metrics.filter(
        (metric) => metric.status === MetricStatus.MISSING_SLICES
      ).length,
      [MetricStatus.MISSING_DEFINITION]: metrics.filter(
        (metric) => metric.status === MetricStatus.MISSING_DEFINITION
      ).length
    }
  }, [metrics])

  return (
    <Box sx={sx}>
      <SectionHeader
        divider={true}
        gutterBottom={true}
        title={t('global', 'status')}
      />

      <NavigationItem
        active={!status}
        item={{
          chip: {
            label: metrics.length
          },
          href: '/metrics',
          title: `${t('global', 'all')} ${t('metrics', 'metrics', true)}`
        }}
      />
      {[
        MetricStatus.ACTIVE,
        MetricStatus.INACTIVE,
        MetricStatus.MISSING_SLICES,
        MetricStatus.MISSING_DEFINITION,
        MetricStatus.MISSING_DATA
      ].map((s) => (
        <NavigationItem
          active={status === translateMetricStatus[s].slug}
          indent={1}
          item={{
            chip: {
              color: translateMetricStatus[s].color,
              label: counts[s]
            },
            onClick: () => setStatus(translateMetricStatus[s].slug),
            title: translateEnum('metric_statuses', s).pluralTitle
          }}
          key={s}
        />
      ))}
    </Box>
  )
})

export default MetricsStatusOverview
